"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetterScrollView = void 0;
const react_1 = __importDefault(require("react"));
const BetterScrollView_style_1 = require("./BetterScrollView.style");
const native_base_1 = require("native-base");
function BetterScrollView({ style = [], children, ...props }) {
    style = [];
    return (react_1.default.createElement(native_base_1.ScrollView, { style: [...[BetterScrollView_style_1.styles.scrollview], ...style], ...props }, children));
}
exports.BetterScrollView = BetterScrollView;
